import { useAirQualitySensorsQuery } from '../Services/API/airQualityApi';
import { useAuth } from 'oidc-react';

export type FeatureSet = {
  hasAqiSensors: boolean;
};

export const useEnabledFeatures = (): FeatureSet => {
  const { userData, isLoading } = useAuth();

  const skipQuery = !userData || isLoading;
  
  const { data: sensors, isSuccess } = useAirQualitySensorsQuery(undefined, { skip: skipQuery });
  const hasAqiSensors = isSuccess && Array.isArray(sensors) && sensors.length > 0;

  return {
    hasAqiSensors,
  };
};